import FetchWrapper from '@mv-submodules/inplant-coreadapter-fe/functions/fetch-wrapper'

export const API = () => FetchWrapper.getInstance('chronoframe')
export const API_PDF = () => FetchWrapper.configInstance('pdf', 'http://localhost:3005/v1')
export const API_FILE = () => FetchWrapper.getInstance('file')
